<ul class="c__tabs-nav" sd-list-inline #tabsContainer>
  @for (tab of allTabs; track tab) {
    <li #tabList (click)="selectTab(tab)">
      @let selected = $index === selectedTabIndex;
      @if (tab.isDropdown) {
        <div class="c__tab-nav" [ngClass]="{
          'is-active': selected,
          'is-disabled': tab.disabled,
          'c--dropdown': tab.isDropdown
        }">
          <ng-container *ngTemplateOutlet="tab.titleElementRef" />
        </div>
      } @else {
        <a class="c__tab-nav" [ngClass]="{
          'is-active': selected,
          'is-disabled': tab.disabled,
          'c--dropdown': tab.isDropdown,
          'is-hidden-tab': tab.isHiddenTab
        }">
          <ng-container *ngTemplateOutlet="tab.titleElementRef" />
        </a>
      }
    </li>
  }
</ul>
@if (animation === animationEnum.slide && layout === tabGroupLayoutEnum.default) {
  <span #activeBar class="c__active-bar"></span>
}
<div class="c__tabs-body">
  <ng-container *ngTemplateOutlet="allTabs[selectedTabIndex]?.bodyElementRef" />
</div>
